<template>
    <div class="cashgift-wrapper" v-if="registerItems.length>0 || cashgiftsItems.length>0">
			<div class="box">
				<div class="container">
          <cashgift-item 
            v-for="(item, index) in registerItems" 
            :key="index" 
            :item="item">                
          </cashgift-item>
        </div>
        <div class="container">
          <cashgift-item 
            v-for="(item, index) in cashgiftsItems" 
            :key="index" 
            :item="item">                
          </cashgift-item>
        </div>
			</div>
			<div class="footer" @click="$router.push({ name: 'cashgiftList', query: { index: 0 } })">
				<div>立即查看</div>
			</div>
		</div>
</template>

<script>
import CashgiftItem from './CashgiftItem'
import { cashgiftList,registerCashgiftList } from '../../../api/cashgift'
import  { cashGiftList }  from  '../../../api/home'

export default {
	components: {
		CashgiftItem,
	},
	data() {
		return {			
			currentIndex: 0,
			tabs: [
				{
					id: 1,
					title: '未使用'
				},
				{
					id: 2,
					title: '已使用'
        },
        {
					id: 3,
					title: '已过期'
				},
			],
      isLoaded: false,
      registerIsLoaded: false,
      page: 1,
      registerPage:1,    
      items: [],  
			registerItems: [],
			cashgiftsItems:[],  
      registerIsMore: 0,
      isMore: 0
		}
	},
	created() {	
		this.loadFirstPageData()	
	},
	activated(){
    this.loadFirstPageData()
  },
	methods: {
		goBack() {
			this.$router.go(-1)
		},
		loadFirstPageData() {
      this.loadPageData(true);
    },
    loadMorePageData() {
      this.loadPageData(false);
    },
    loadPageData(isFirstPage) {
      let page = 1
      let status = 0
      if (isFirstPage) {
        page = 1        
      } else {
        page = this.page + 1    
      }
			let per_page = 10
			let  after = this.$cookie.get('after') || parseInt(new Date().getTime()/1000);
      cashGiftList(status, per_page, page, after).then(res => {         
        if (res && res.cashgifts) {          
					this.cashgiftsItems = res.cashgifts
					this.$cookie.set('after',parseInt(new Date().getTime()/1000))
				}else{
					this.$cookie.set('after',after)
				}
      }, error => {     
				this.$cookie.set('after',after)
			})
			registerCashgiftList(per_page, page,status, after).then(res => {         
        if (res && res.cashgifts) {          
					this.registerItems =  res.cashgifts
					this.$cookie.set('after',parseInt(new Date().getTime()/1000))
				}else{
					this.$cookie.set('after',after)
				}
      }, error => {     
				this.$cookie.set('after',after)
			})          
    },
		onIndexChange(index) {
      this.currentIndex = index
      this.loadFirstPageData()
    },
    loadMore() {  
      if (this.isMore) {
        this.loadMorePageData()
      }          
    }
	},	
}
</script>

<style lang="scss" scoped>
.cashgift-wrapper{
		z-index: 2000;
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		background-color:rgba(0, 0, 0, 0.5);
		padding-top:20vh;
		margin-bottom:20vh;
		.box{
			border-radius: 6vw;
			padding-top: 3vh;
			padding-bottom: 3vh;
			width: 80vw;
			background-color:rgb(255, 0, 0);
			text-align: center;
		}
		.footer{
			border-radius: 6vw;
			margin-top: 4vw;
			width: 40vw;
			height: 6vh;
			line-height: 6vh;
			color:rgb(233, 230, 40);
			font-size: 0.8rem;
			text-align: center;
			background-color:rgb(255, 0, 0);
		}
}
.container {
  display: flex;
  position: relative;
	flex-direction: column;
	justify-content: flex-start;
	align-items: stretch;
	background-color:rgb(255, 0, 0);
}
.header {
	@include header;
	border-bottom: 1px solid $lineColor;
}
.topList {
  position: fixed;
  width: 100%;
	margin-top: 44px;	
  height: 40px;		
  z-index: 100;
}
.list-wrapper { 
  margin-top: 92px;
}
</style>



// WEBPACK FOOTER //
// src/page/home/child/CashgiftList.vue